import React from 'react';

/**
 * Parses an agent-supplied href and returns the URL only when it is an
 * absolute https: URL. Relative, protocol-relative (`//host`), http:,
 * mailto:, javascript: and anything unparseable return null
 * (2026-09-25 gap closure).
 * @param {unknown} href
 * @returns {URL|null}
 */
export function parseSafeHref(href) {
  if (typeof href !== 'string' || !href) return null;
  let url;
  try {
    // No base URL: a relative or protocol-relative href throws here.
    url = new URL(href);
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' || !url.hostname) return null;
  return url;
}

/**
 * Markdown link renderer for agent text. Agent output is hostile: only an
 * absolute https link becomes a clickable anchor, it always shows the real
 * destination host (so link text cannot disguise it), opens in a new tab and
 * sends no opener or referrer. Everything else renders as plain text
 * (2026-09-25 gap closure).
 */
export default function SafeMarkdownLink({ href, children }) {
  const url = parseSafeHref(href);
  if (!url) {
    return <span className="il-md-link-blocked">{children}</span>;
  }
  return (
    <>
      <a
        href={url.href}
        target="_blank"
        rel="noopener noreferrer"
        referrerPolicy="no-referrer"
      >
        {children}
      </a>
      <span className="il-md-link-host"> ({url.hostname})</span>
    </>
  );
}
